import { UNIDADES, SITUACIONES, SI_NO } from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'drenajesTransversales',
    familyFragment,
    [TYPES.OTDL]
  ),

  {
    label: 'Nº O.F.',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'identificacion',
      'numOF'
    ]
  },

  {
    label: 'Tipología del elemento hidráulico',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'identificacion',
      'tipologiaElementoHidraulico'
    ]
  },

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Situación de la entrada',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'situacionEntrada'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Situación de la salida',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'situacionSalida'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos entrada',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'fotosEntrada'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos salida',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'inspeccion',
      'fotosSalida'
    ],
    meta: { isPhotos: true }
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'Desbroce',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'desbroce'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Medición Desbroce',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'medicionDesbroce'
    ]
  },

  {
    label: 'Unidad Desbroce',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'unidadDesbroce'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Limpieza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'limpieza'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Medición Limpieza',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'medicionLimpieza'
    ]
  },

  {
    label: 'Unidad Limpieza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'unidadLimpieza'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  }
]

export const validacion = (workOrderFragment, familyFragment) => [
  {
    label: 'Responsable Contratista',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'responsableContratista'
    ]
  },

  {
    label: 'Fecha',
    type: 'Date',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'fecha'
    ]
  },

  {
    label: 'Situación de la entrada',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'situacionEntrada'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Situación de la salida',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'situacionSalida'
    ],
    meta: {
      options: SITUACIONES
    }
  },

  {
    label: 'Auditado',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'auditado'
    ],
    meta: {
      placeholder: 'Sin especificar',
      options: SI_NO
    }
  },

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'comentarios'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos entrada',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'fotosEntrada'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos salida',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'fotosSalida'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'drenajesTransversales',
      familyFragment,
      'validacion',
      'fotos'
    ],
    meta: { isPhotos: true }
  }
]
